import script from "./AgendaSessionView.vue?vue&type=script&setup=true&lang=js"
export * from "./AgendaSessionView.vue?vue&type=script&setup=true&lang=js"

import "./AgendaSessionView.vue?vue&type=style&index=0&id=4cca1ffe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cca1ffe"]])

export default __exports__